// Approving a task or subtask can fire a trigger action that creates a module server-side. The
// page that was open has no way to know, so the api layer announces it and the grant page re-reads
// its modules.
export const GRANT_MODULES_MAY_HAVE_CHANGED = "grant-modules-may-have-changed";

export const announceGrantModulesMayHaveChanged = () =>
    window.dispatchEvent(new CustomEvent(GRANT_MODULES_MAY_HAVE_CHANGED));
